/**
 * Learn — `/learn` route.
 *
 * Body is the hand-built design from `learn.html`. Navbar + Footer +
 * App.js routing all unchanged.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { LearnHero } from "../components/LearnHero";

export default function Learn() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="learn-page">
      <Helmet>
        <title>Learn : T-REX Network</title>
      </Helmet>
      <Navbar />
      <div aria-hidden="true" style={{ height: 64 }} />
      <LearnHero />
      <Footer />
    </main>
  );
}
